export const thumbnailScrollState = ({ position, viewport, content }) => {
  const maximum = Math.max(0, content - viewport);
  return {
    maximum,
    canPrevious: viewport > 0 && position > 1,
    canNext: viewport > 0 && position < maximum - 1,
  };
};

export const thumbnailScrollTarget = ({ position, viewport, content }, direction) => {
  const maximum = Math.max(0, content - viewport);
  return Math.max(0, Math.min(maximum, position + direction * Math.max(80, viewport * 0.8)));
};
